import gsap from 'gsap';

$(".hero-type-1:not(.-full) .open-more").on("click", function () {
    const thisBox = $(this).closest(".hero-type-1").find(".overflowed-block");
    const windowWidth = $(window).width();
    const boxHeight = calculateBoxHeight(windowWidth);

    $(this).toggleClass("-open");
    thisBox.toggleClass("-open");

    if ($(this).hasClass("-open")) {
        expandHeroGallery(thisBox[0]);
    } else {
        closeHeroGallery(thisBox[0], boxHeight);
    }
});

$(document).ready(function () {
    checkBoxHeight();
});

$(window).resize(function () {
    resetParameters();
    checkBoxHeight();
});

function calculateBoxHeight(windowWidth) {
    if (windowWidth < 1440 && windowWidth >= 1024) {
        return 400;
    } else if (windowWidth < 1024 && windowWidth >= 768) {
        return 304;
    } else if (windowWidth < 768) {
        return 320;
    }
    return 420;
}

function expandHeroGallery(thisBox) {
    gsap.timeline()
        .to(thisBox, {
            duration: 1,
            delay: 0.1,
            height: "auto",
            ease: "power4.out"
        })
}

function closeHeroGallery(thisBox, height) {
    gsap.timeline()
        .to(thisBox, {
            delay: 0.1,
            duration: 1,
            ease: "power4.out",
            height: height,
        })
}


function checkBoxHeight() {
    $('.hero-type-1').each(function (i) {
        let windowWidth = $(window).width();
        let thisText = $(this).find('.title-box');
        let thisBox = $(this).find('.overflowed-block');
        let thisHeight = thisText.innerHeight();

        if ((windowWidth >= 1440 && thisHeight <= 420) || (windowWidth < 1440 && windowWidth >= 1024 && thisHeight <= 400) || (windowWidth < 1024 && windowWidth >= 768 && thisHeight <= 304) || (windowWidth < 768 && thisHeight <= 320)) {
            thisBox.addClass('-no-open');
        } else {
            thisBox.removeClass('-no-open');
        }
    })
}

function resetParameters() {
    $('.hero-type-1:not(.-full)').each(function (i) {
        let thisBox = $(this).find(".overflowed-block");
        let thisButton = $(this).find(".open-more");
        let windowWidth = $(window).width();
        let boxHeight = calculateBoxHeight(windowWidth);

        if (!thisBox.hasClass('-no-open')) {
            thisButton.removeClass("-open");
            thisBox.removeClass("-open");
        }
        closeHeroGallery(thisBox[0], boxHeight);
    })
}